/**
 * RESPONSIBILITY: one photograph in a ministry band's gallery.
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Img } from '@framework/core/decorators';

@Row()
export class MinistryPictureRow {
  @Img({ label: 'Picture', folder: 'ministries', maxSizeMb: 12, size: '1200 × 800' })
  image!: ImageValue;

  @Text({ label: 'Caption', maxLength: 300 })
  caption!: string;
}
